"use client";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "@/components/ui/popover";
import { IUserData } from "@/types";
import AdminPopover from "../../../content/AdminPopover";
import { masks } from "@/lib/imageMasks";

interface Props {
    user: IUserData;
    admin?: boolean;
    className?: string;
}

export default function UserImage({
    user,
    admin,
    className = "size-32",
}: Props) {
    return (
        <div
            className={`relative ${className} shrink-0`}
            id={"profile-picture"}
        >
            <img
                src={user.pic}
                className={`${className} shrink-0 `}
                style={{
                    width: "100%",
                    height: "100%",
                    WebkitMask: masks[user.design.profile_pic_shape],
                    mask: masks[user.design.profile_pic_shape],
                }}
                alt={user.username}
            />
        </div>
    );
}
